var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInsertVideo = function SvgInsertVideo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M14.168 11.612c.015.472.23.916.594 1.221l.833.7c1.084.911 2.739.14 2.739-1.276V7.744c0-1.416-1.655-2.187-2.739-1.277l-.833.7a1.667 1.667 0 0 0-.594 1.215m0 3.23-.001.888a3.333 3.333 0 0 1-3.333 3.334H5A3.333 3.333 0 0 1 1.667 12.5v-5A3.333 3.333 0 0 1 5 4.167h5.834A3.333 3.333 0 0 1 14.167 7.5l.001.882m0 3.23v-3.23"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInsertVideo);
export default ForwardRef;